import { WITH_MASTER_CONNECTOR } from "../config/constant";

export const clearDoorKey = () => {

  let door_key_type = localStorage.getItem("door_key_type");

  // remove the dormakaba files from device

  return new Promise((resolve, reject) => {
    try {
      //This is to clear the door key store in for assa abloy door key feature.

      if (window.device) {
        if (window.device.platform == "Android") {

          if (door_key_type == "AA") {
            if (window.assaabloy) {
              window.assaabloy.clearedSharedPref();
              setTimeout(() => { resolve() }, 1500);
              return;
            }
          }

          if (door_key_type == "DK") {
            if (window.dormakaba) {
              window.dormakaba.clearedSharedPref();
              setTimeout(() => { resolve() }, 1500);
              return;
            }
          }

          if(door_key_type == "SALTO") {
            if(window.salto) {
              window.salto.clearedSharedPref();
              setTimeout(() => { resolve() }, 1500);
              return;
            }
          }

          resolve();
        } else {

          if (door_key_type == "AA") {
            if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy) {
              window.cordova.plugins.AssaAbloy.terminateEndpoint(
                "hello",
                () => { console.log("terminateEndpoint success") },
                () => { console.log("terminateEndpoint failed") }
              );

              setTimeout(() => { resolve() }, 1500);
              return;
            }
          }

          if (door_key_type == "DK") {
            if (window.cordova && window.cordova.plugins && window.cordova.plugins.Dormakaba) {
              window.cordova.plugins.Dormakaba.terminateEndpoint(
                "hello",
                () => { console.log("terminateEndpoint success") },
                () => { console.log("terminateEndpoint failed") }
              );

              setTimeout(() => { resolve() }, 1500);
              return;
            }
          }

          if (door_key_type == "SALTO") {
            if (window.cordova && window.cordova.plugins && window.cordova.plugins.Salto) {
              window.cordova.plugins.Salto.terminateEndpoint(
                "hello",
                () => { console.log("terminateEndpoint success") },
                () => { console.log("terminateEndpoint failed") }
              );

              setTimeout(() => { resolve() }, 1500);
              return;
            }
          }

          resolve();
        }
      } else {
        resolve()
      }

    } catch (e) {
      resolve()
      console.log("error clearedSharedPref android menthod call", e);
    }
  });
}


export const wipeGuestData = async (wipeDataProps) => {

  const asyncTasks = [];
  console.log("wipeGuestData")
  let room = localStorage.getItem("room");
  let newSession = sessionStorage.getItem('newSession');
  let guestCheckout = sessionStorage.getItem('guestCheckout');
  let FbInfo = localStorage.getItem("FB_user_info");
  let userProfile = localStorage.getItem("user_profile");
  let twitterToken = localStorage.getItem('twitterAccessToken');
  let twitterData = localStorage.getItem('TwitterUserData');
  let twitterSecret = localStorage.getItem('twitterAccessTokenSecret');
  let savedOrders = localStorage.getItem('savedOrders');
  let placedOrder = localStorage.getItem('placedOrder');
  let sessionToken = localStorage.getItem('GuestJourneySessionToken');
  let VerifiedUser = localStorage.getItem('VerifiedUser')
  let PMSVerifiedUser = localStorage.getItem('PMSVerifiedUser')
  let profile_photo = localStorage.getItem("profile_photo");

  if (!newSession || (guestCheckout !== "false") || true) {
    sessionStorage.setItem('newSession', true);
    sessionStorage.setItem('guestCheckout', false);
    if (FbInfo)
      localStorage.setItem("FB_user_info", null);
    if (userProfile)
      localStorage.setItem("user_profile", null);
    if (twitterToken)
      localStorage.setItem('twitterAccessToken', null);
    if (twitterData)
      localStorage.setItem('TwitterUserData', null);
    if (twitterSecret)
      localStorage.setItem('twitterAccessTokenSecret', null);
    if (savedOrders)
      localStorage.setItem('savedOrders', null);
    if (placedOrder)
      localStorage.setItem('placedOrder', null);
    if (room && room !== "null")
      localStorage.setItem('room', null);
    if (sessionToken)
      localStorage.setItem('GuestJourneySessionToken', "");
    if (VerifiedUser)
      localStorage.removeItem('VerifiedUser')
    if (profile_photo)
      localStorage.removeItem('profile_photo')

    localStorage.removeItem("accompanyGuestId");
    localStorage.removeItem("Check_In_Guest_List")
    localStorage.removeItem("guestToken")
    localStorage.removeItem("Guest_Details")
    localStorage.removeItem("Set_Current_Logged_In_Guest_Details")
    localStorage.removeItem("resReservationCustomerId")
    localStorage.removeItem("resReservationClientId")
    localStorage.removeItem("resReservationEmail")
    localStorage.removeItem("GuestListSetTimestamp")
    localStorage.removeItem('VerifiedUser')
    localStorage.removeItem("door_key_opened")
    localStorage.removeItem('GuestCheckedOut')
    localStorage.removeItem("GuestIsCheckin")
    localStorage.removeItem("selfieVideoUrl")
    localStorage.removeItem("adHocEventShownIDList")
    localStorage.removeItem("checkInGuestPreInfo");
    localStorage.removeItem("checkinSessionBookingNumber")
    localStorage.removeItem("extra_guest_details");
    localStorage.removeItem("X_CHECKIN_PQ_DATA");
    sessionStorage.removeItem("X_CHECKIN_PQ_DATA");
    localStorage.removeItem("roomControlInterface")
    localStorage.removeItem("marketSegmentCode");


    if(WITH_MASTER_CONNECTOR && localStorage.getItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST") && localStorage.getItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST") != "null"){

      let preCheckInDataHotelSpecificList = JSON.parse(localStorage.getItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST")) || [];
      const clientId = localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG;

      preCheckInDataHotelSpecificList = preCheckInDataHotelSpecificList.reduce((acc, curr)=>{

        if(curr.clientId != clientId ) acc.push( curr );
        
        return acc;
      },[])

      localStorage.setItem("X_CHECKIN_PQ_DATA_HOTEL_SPECIFIC_LIST", JSON.stringify(preCheckInDataHotelSpecificList));
      
    }


    // do not remove this in InRoomTab build.
    !wipeDataProps.inRoomTab && localStorage.removeItem("roomID")

    await clearDoorKey();
    localStorage.removeItem("door_key_type");

    // remove Chat login data
    try {

      // remove Zingle
      if (window.device && window.Smooch) {
        console.log("Zingle Logout Inittiated")
        window.Smooch.logout()
      } else {
        console.log("Zingle logout Initiated for web")
        localStorage.removeItem("zingleCred")
      }

    } catch (error) {
      console.log("error logging out from chat", error);
    }

    // remove InnSpireChatBot
    localStorage.removeItem("innSpireChatLoginInit");
    if (window.InnspireCB && window.InnspireCB.chatbot) {
      asyncTasks.push(
        new Promise(async (resolve) => {
          try {
            await window.InnspireCB.chatbot.logout();
          } catch (error) {
            // Handle logout error if needed
          } finally {
            resolve();
          }
        })
      )
    }

    await Promise.all(asyncTasks);
    setTimeout(() => {
      window.location.reload();
    }, 10);
  }
}